export default __webpack_public_path__ + "static/media/Blacksulphur Armbands.e21d6931.jpg";